import { render, staticRenderFns } from "./ChatSwitcher.vue?vue&type=template&id=ba8f5f86&scoped=true"
import script from "./ChatSwitcher.vue?vue&type=script&lang=js"
export * from "./ChatSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ChatSwitcher.vue?vue&type=style&index=0&id=ba8f5f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f5f86",
  null
  
)

export default component.exports